import { getCookie } from '../utils/cookie';

import request, { apiURL, del, put, get } from '../utils/api';
class ApplicantService {
  getAllApplicantsByHouseholdId(
    organizationId: string,
    propertyId: string,
    householdId: string,
  ) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };

    return request(
      `${apiURL}/${organizationId}/${propertyId}/applicants/household/${householdId}`,
      options,
    );
  }

  updateApplicant(
    organizationId: string,
    propertyId: string,
    applicantId: string,
    payload: Object,
    isAdult: boolean,
    options?: Object,
  ) {
    const path = isAdult ? 'applicant' : 'applicantMinor';
    return put(
      `/${organizationId}/${propertyId}/${path}/${applicantId}/update`,
      JSON.stringify(payload),
      options,
    );
  }

  /** Permanently deletes an Applicant record. */
  hardDeleteApplicant(
    organizationId: string,
    propertyId: string,
    applicantId: string,
    options?: Object,
  ) {
    // Preserve the empty body argument so `options` carries the abort signal.
    return del(
      `/${organizationId}/${propertyId}/applicant/${applicantId}/hard-delete`,
      undefined,
      options,
    );
  }

  getApplicant(
    organizationId: string,
    propertyId: string,
    applicantId: string,
    options?: Object,
  ) {
    return get(
      `/${organizationId}/${propertyId}/applicant/${applicantId}`,
      options,
    );
  }
}

export default ApplicantService;
